import { useState, useCallback } from 'react';

/**
 * 모달 상태를 관리하는 커스텀 훅
 * @param {Object} options
 * @param {*} options.initialData - 모달에 전달할 초기 데이터 (기본: null)
 * @returns {{ isOpen: boolean, data: *, open: Function, close: Function, toggle: Function }}
 */
export function useModal(options = {}) {
  const { initialData = null } = options;
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(initialData);

  const open = useCallback((modalData = null) => {
    setData(modalData);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setData(initialData);
  }, [initialData]);

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return { isOpen, data, open, close, toggle };
}
